import { useMemo } from 'react';

export default function usePageLanguagePrefix(): string {
    return useMemo(function () {
        const path = window.location.pathname;
        if (path === '' || path === '/') {
            return '';
        }

        const language = path.split('/').filter(Boolean)[0];
        if (language.length > 2) {
            return '';
        }

        return language;
    }, []);
}
